export default __webpack_public_path__ + "b95f887ae87f1b61abf2b15ec4540cd3.webp";